const base = {
  url: "//sdk.qcplay.com", //生产环境
  // url: "//tsdk.qcplay.com", //测试环境
  wechat: "//api.qingcigame.com", //微信授权专用
}

export default base
